// src/components/sla/ai/SlaGradeBadge.js
// Letter grade (A-F) disc with the score; used in tables, the decision explainer and the scoreboard.
import React, { memo } from 'react';
import { Box, Flex, Text, Tooltip, useColorModeValue } from '@chakra-ui/react';
import { GRADE_SCHEME } from './slaAiFormat';

const SIZES = { sm: { box: '28px', letter: 'sm', score: '2xs' }, md: { box: '40px', letter: 'lg', score: 'xs' }, lg: { box: '64px', letter: '3xl', score: 'sm' } };

function SlaGradeBadge({ grade, score, size = 'md', label, projected = false }) {
    const scheme = GRADE_SCHEME[grade] || 'gray';
    const bg = useColorModeValue(`${scheme}.50`, `${scheme}.900`);
    const fg = useColorModeValue(`${scheme}.600`, `${scheme}.200`);
    const border = useColorModeValue(`${scheme}.200`, `${scheme}.600`);
    const muted = useColorModeValue('gray.500', 'gray.400');
    const s = SIZES[size] || SIZES.md;
    const tip = grade ? `${projected ? 'Projected grade' : 'Grade'} ${grade}${score != null ? ` · ${score}/100` : ''}${label ? ` · ${label}` : ''}` : 'Not graded yet';
    return (
        <Tooltip label={tip} hasArrow openDelay={300}>
            <Flex align="center" gap={2} display="inline-flex" aria-label={tip}>
                <Flex
                    w={s.box} h={s.box} minW={s.box} borderRadius="full" bg={bg} color={fg} borderWidth="2px" borderColor={border}
                    borderStyle={projected ? 'dashed' : 'solid'} align="center" justify="center" fontWeight="800"
                >
                    <Text fontSize={s.letter} lineHeight="1">{grade || '–'}</Text>
                </Flex>
                {score != null && size !== 'sm' && (
                    <Box lineHeight="1.1">
                        <Text fontWeight="700" fontSize={s.score === '2xs' ? 'xs' : 'sm'}>{score}</Text>
                        <Text fontSize="2xs" color={muted}>{projected ? 'projected' : 'score'}</Text>
                    </Box>
                )}
            </Flex>
        </Tooltip>
    );
}

export default memo(SlaGradeBadge);
